var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "i-map" },
    [
      _vm.isLoading
        ? [_vm._m(0)]
        : [
            _c("iframe", {
              staticStyle: { border: "0" },
              attrs: {
                id: "google-map",
                loading: "lazy",
                referrerpolicy: "no-referrer-when-downgrade",
                src: `https://www.google.com/maps/embed/v1/place?key=${_vm.key}&q=${_vm.placeParameter}`,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading" }, [
      _c("img", { attrs: { src: require("@/assets/images/loading.svg") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }